import { lazy } from 'react'

export default {
    path: '/assegnazioni/:assegnazioneId',
    title: 'Permesso: {{params.assegnazioneId}}',
    component: lazy(() => import('./detail'))
}